<template>
	<div>
		<slot></slot>
	</div>
</template>

<script>
	import { shareProtocol } from '@/common/SharedDataScope';
	import { createLanguageMap } from '@/common/18nhelper';

	export default {
		props: {
			context: {
				type: Object,
				require: true,
			},
			namespace: {
				type: Array | Function,
				default: Array,
			},
			xplainer: {
				type: Object,
				default: null,
			},
			// requirement输入为Array<string>,若想利用函数判断,请在组件内单独指定,并且若单独指定了函数判断,这里的记录就自动失效
			requirement: {
				type: Array,
				default: null,
			},
		},
		provide() {
			// 构建语言依赖
			let t;
			if (typeof this.namespace === 'function') {
				t = this.namespace;
			} else {
				t = createLanguageMap.apply(undefined, this.namespace);
			}
			const defaultXplainer = {
				label: (str, ...p) => t('label_' + str, ...p),
				placeholder: (str, ...p) => t('label_' + str + '_hint', ...p),
				require: (str, ...p) => t('require', t('label_' + str, ...p)),
				t,
			};

			if (this.xplainer !== null) {
				Object.assign(defaultXplainer, this.xplainer);
			}

			// 构建表单必填项依赖
			let required;

			if (this.requirement instanceof Array) {
				required = new Set(this.requirement);
			} else {
				required = { has: () => false };
			}

			return {
				// report.
				report: (obj) => {
					this.report = obj;
					this.aftReport();
				},
				core: this,
				xpl: defaultXplainer,
				required,
				getCtx: () => this.userInput,
			};
		},
		data() {
			return {
				// 由Card子组件负责维护,用于渲染一个form
				step: 0,
				/**子组件回报列表 */
				report: null,
			};
		},
		computed: {
			...shareProtocol('context', ['userInput']),
		},
		methods: {
			/**初始化函数,由子组件的回报操作触发 */
			aftReport() {},
			commit() {},
			cancel() {},
			/**进行表单验证,如不通过则静默失败,成功则执行传入的回调 */
			async tryCheck(cb) {
				try {
					// 依赖于children的特定结构才能正确运行
					for (let item of this.$children) {
						await item.$children[0].validate();
					}
				} catch (e) {
					// 异常则静默失败
					return;
				}
				cb();
			},
		},
	};
</script>
